import { Form } from "react-bootstrap";

// Lazy load to avoid circular dependency in @rjsf/core
let DefaultUpDownWidget = null;
function getDefaultUpDownWidget() {
    if (!DefaultUpDownWidget) {
        DefaultUpDownWidget = require("@rjsf/core/lib/components/widgets/UpDownWidget").default;
    }
    return DefaultUpDownWidget;
}

export const UpDownWidget = props => {
    const Widget = getDefaultUpDownWidget();
    return (
        <Form.Group className="mb-0">
            <Form.Label className={props.rawErrors ? "text-danger" : ""}>{props.label}</Form.Label>
            <Widget {...props} />
        </Form.Group>
    );
};
